// ABOUTME: Who hears each item's changes in a discussion store kept outside React — the outbox, the drafts: a window
// ABOUTME: subscribes to its item, as useSyncExternalStore takes it, and hears only that item's changes.

export function itemListeners() {
  const byItem = new Map<string, Set<() => void>>()

  /** The returned function stops listening. */
  const subscribe = (itemId: string, listener: () => void): (() => void) => {
    const set = byItem.get(itemId) ?? new Set()
    set.add(listener)
    byItem.set(itemId, set)
    return () => {
      set.delete(listener)
      // A set dropped by `clear` meanwhile is not the item's any more: the one subscribed after stays.
      if (set.size === 0 && byItem.get(itemId) === set) byItem.delete(itemId)
    }
  }

  const notify = (itemId: string): void => {
    byItem.get(itemId)?.forEach((listener) => listener())
  }

  /** Test seam: nobody hears any more. */
  const clear = (): void => {
    byItem.clear()
  }

  return { subscribe, notify, clear }
}
